var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursoricon = function SvgCursoricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.42.08 10.014 5.696a.392.392 0 0 1-.152.704l-3.58.8 3.435 5.928a.599.599 0 0 1 .056.456l-.08.296a.6.6 0 0 1-.28.36l-2.753 1.6a.604.604 0 0 1-.305.08h-.153l-.265-.096a.618.618 0 0 1-.369-.28L5.554 9.696 3.098 12.4a.402.402 0 0 1-.698-.272V.656a.616.616 0 0 1 .32-.52L2.818.08a.603.603 0 0 1 .602 0Zm4.112 6.23a.401.401 0 0 1 .284-.229l2.102-.48-5.914-3.336v6.76L5.48 7.408a.41.41 0 0 1 .65.064l3.893 6.672 1.388-.8-3.86-6.672a.399.399 0 0 1-.02-.363Z",
    clipRule: "evenodd"
  })));
};
export default SvgCursoricon;